import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import {authStorageService} from '../services/service-factory';
import appConfig from '../app.config';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((route) => route.meta.requiresAuth) &&
    !authStorageService.isAuthenticated()) {
    next({
      name: 'sign-in'
    });
  } else {
    next();
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title ? `${appConfig.appName} - ${to.meta.title}` : appConfig.appName;
  });
});

export default router;
